import { LeadStatusDto } from '@sr/dto';
import { fetchLeadQualityDropdown } from 'entities/lead/api';
import { useReadOnlyRemoteCollection } from 'utils/remote-collection.hook';

export const useLeadQualityDropdown = () => {
  return useReadOnlyRemoteCollection<LeadStatusDto>({
    fetchHandler: fetchLeadQualityDropdown
  });
};
